import React from 'react';
import Bounce from 'react-reveal/Bounce';
import ContactForm from '../components/Contact/ContactForm';

const ContactScreen = () => {
    return (
        <section className="max-w-screen-xl py-24 mx-auto px-6 overflow-y-hidden">
            {/* Titre */}
            <Bounce left>
                <div className="flex flex-col items-center pb-4">
                    <h1 className="text-gray-700 poppins text-3xl">
                        Contactez{" "}
                        <span className="text-paragaia font-semibold select-none">Nous</span>
                    </h1>
                    <div className="bg-paragaia flex items-center justify-center w-16 h-1 mt-2 rounded-full"></div>
                </div>
            </Bounce>

            {/* Formulaire */}
            <ContactForm />
        </section>
    );
};

export default ContactScreen;
